export default "__VITE_ASSET__jnVkS3v1__"